// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__3t7c9","resendInfoText":"OnGoingPaymentBox_resendInfoText__2a01F"};